// This is a debug file to help identify issues with the profile form submission
console.log('Debug profile form submission');

// Function to check form submission
export const debugProfileSubmission = (formData) => {
  console.log('Debug profile submission called with data:', formData);
  
  // Check if required fields are present
  const { firstName, lastName, userType, venueName, venueType, professions } = formData;
  
  console.log('Required fields check:');
  console.log('- First name:', firstName ? 'Present' : 'Missing');
  console.log('- Last name:', lastName ? 'Present' : 'Missing');
  console.log('- User type:', userType);
  
  if (userType === 'venue') {
    console.log('- Venue name:', venueName ? 'Present' : 'Missing');
    console.log('- Venue type:', venueType ? 'Present' : 'Missing');
  } else if (userType === 'artist') {
    console.log('- Professions:', professions && professions.length > 0 ? 'Present' : 'Missing');
  }
  
  return {
    isValid: true,
    message: 'Form data is valid'
  };
};
